<template>
  <section class="image-module" v-if="content.image">
    <figure>
      <img :src="content.image.data.full_url" alt />
      <figcaption>{{content.image_caption}}</figcaption>
    </figure>
  </section>
</template>


<script>
export default {
  props: {
    content: {
      type: Object
    }
  }
};
</script>